<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 2016.21 206.93"
    :aria-labelledby="iconName"
    role="presentation"
  >
    <title :id="iconName" lang="en">{{ iconName }}</title>
    <path
      d="M21.83,335.19V140.65l132.84,139V153h27.48V346.28L49.31,207.66V335.19Z"
      transform="translate(-21.83 -139.35)"
      :fill="iconColor"
    ></path>
    <path
      d="M253.29,153V335.19H225.81V153Z"
      transform="translate(-21.83 -139.35)"
      :fill="iconColor"
    ></path>
    <path
      d="M390.74,240.34H466v6q0,20.52-4.83,36.33a77.23,77.23,0,0,1-15.93,27.37q-25.37,28.56-64.53,28.55-38.22,0-65.48-27.6T288,244.47q0-39.65,27.72-67.25t67.49-27.72a92.35,92.35,0,0,1,39.87,8.73q17.7,8.73,34.8,28.31L438.28,205.3q-22.41-29.85-54.62-29.85-28.91,0-48.49,19.94Q315.58,215,315.59,244.47q0,30.43,21.82,50.14,20.41,18.28,44.24,18.29,20.3,0,36.46-13.69t18.05-33H390.74Z"
      transform="translate(-21.83 -139.35)"
      :fill="iconColor"
    ></path>
    <path
      d="M528.06,224.3h78.57V153h27.49V335.19H606.63V250.13H528.06v85.06H500.57V153h27.49Z"
      transform="translate(-21.83 -139.35)"
      :fill="iconColor"
    ></path>
    <path
      d="M728,178.88V335.19H700.54V178.88H658.66V153H769.79v25.84Z"
      transform="translate(-21.83 -139.35)"
      :fill="iconColor"
    ></path>
    <path
      d="M788,335.19,826.3,139.35l62.53,141.57L953.6,139.35l34.45,195.84h-28.2L942.27,225.24,888.36,343.57,836,225.12,816.39,335.19Z"
      transform="translate(-21.83 -139.35)"
      :fill="iconColor"
    ></path>
    <path
      d="M1017.54,243.29q0-38.46,28.2-66.07t67.48-27.6q38.94,0,66.77,27.84t28,66.89q0,39.29-28.08,66.66T1111.8,338.5q-35.27,0-63.35-24.42Q1017.53,287.07,1017.54,243.29Zm27.73.35q0,30.21,20.29,49.67t46.6,19.47q28.66,0,48.37-19.82,19.7-20.06,19.7-48.84,0-29.15-19.47-48.85t-47.89-19.82q-28.44,0-48,19.82Q1045.26,214.86,1045.27,243.64Z"
      transform="translate(-21.83 -139.35)"
      :fill="iconColor"
    ></path>
    <path
      d="M1304.22,257.56l56.4,77.63H1327l-52-74.56h-5v74.56h-27.49V153h32.21q36.11,0,52.15,13.57,17.68,15.09,17.69,39.87,0,19.35-11.09,33.27A49.4,49.4,0,0,1,1304.22,257.56ZM1270,236.68h8.73q39,0,39-29.85,0-28-38-28H1270Z"
      transform="translate(-21.83 -139.35)"
      :fill="iconColor"
    ></path>
    <path
      d="M1388,335.19V140.65l132.84,139V153h27.48V346.28L1415.47,207.66V335.19Z"
      transform="translate(-21.83 -139.35)"
      :fill="iconColor"
    ></path>
    <path d="M1619.45,153V335.19H1592V153Z" transform="translate(-21.83 -139.35)" :fill="iconColor"></path>
    <path
      d="M1663.22,335.19V140.65l132.84,139V153h27.49V346.28L1690.71,207.66V335.19Z"
      transform="translate(-21.83 -139.35)"
      :fill="iconColor"
    ></path>
    <path
      d="M1962.76,240.34H2038v6q0,20.52-4.83,36.33a77.23,77.23,0,0,1-15.93,27.37q-25.37,28.56-64.53,28.55-38.23,0-65.48-27.6T1860,244.47q0-39.65,27.72-67.25t67.48-27.72a92.36,92.36,0,0,1,39.88,8.73q17.7,8.73,34.8,28.31l-19.58,18.76q-22.43-29.85-54.62-29.85-28.9,0-48.49,19.94-19.59,19.59-19.59,49.08,0,30.43,21.83,50.14,20.4,18.28,44.24,18.29,20.29,0,36.45-13.69t18-33h-45.42Z"
      transform="translate(-21.83 -139.35)"
      :fill="iconColor"
    ></path>
  </svg>
</template>

<script>
export default {
  props: {
    iconName: {
      type: String,
      default: "NightMorning Logo"
    },
    width: {
      type: [Number, String],
      default: "100%"
    },
    height: {
      type: [Number, String],
      default: "100%"
    },
    iconColor: {
      type: String,
      default: "#ffffff"
    }
  }
};
</script>